<template>
  <div :class="$style.slider" :style="{
    '--transition-duration': `${transition}ms`,
    '--direction': `${direction}`
    }">
    <template v-if="slides">
      <transition name="slider">
        <Slide
          :slide="slide"
          :key="slide.id"
          @next="nextSlide"
          @prev="prevSlide"
        >
          <slot :currentSlide="currentSlide" :methods="{ nextSlide, prevSlide }" :slide="slide" />
        </Slide>
      </transition>
    </template>
  </div>
</template>

<script type="text/babel">
import Slide from './Slide.vue';

export default {
  components: {
    Slide,
  },
  props: {
    title: {
      required: true,
    },
    slides: {
      type: Array,
      default() {
        return [
          {
            text: 'Text 1',
          },
          {
            text: 'Text 2',
          },
        ];
      },
    },
  },
  data() {
    return {
      currentSlide: 0,
      direction: 1,
      transition: 750,
      autoplay: true,
      duration: 5000,
      $interval: null,
    };
  },
  computed: {
    slide() {
      const id = this.currentSlide;
      const slide = this.slides[id];
      return {
        ...slide,
        ...{
          id,
          title: this.title,
        },
      };
    },
    slideCount() {
      return (this.slides) ? this.slides.length : 0;
    },
  },
  methods: {
    startQuiz() {
      console.log('Start Quiz');
    },
    setSlide(slide) {
      this.direction = Math.sign(slide - this.currentSlide);
      this.currentSlide = slide;
    },
    prevSlide() {
      if (this.currentSlide > 0) {
        this.setSlide(this.currentSlide - 1);
      } else {
        this.setSlide(this.slideCount - 1);
      }
    },
    nextSlide() {
      if (this.currentSlide < this.slideCount - 1) {
        this.setSlide(this.currentSlide + 1);
      } else {
        this.setSlide(0);
      }
    },
  },
};
</script>

<style lang="scss" module>
  .slider {
    &-enter-active, &-leave-active {
      transition: opacity var(--transition-duration), transform var(--transition-duration);
    }
    &-enter, &-leave-to {
      /*opacity: 0;*/
    }
    &-enter {
      transform: translateX(calc(100% * var(--direction)));
    }
    &-leave-to {
      transform: translateX(calc(-100% * var(--direction)));
    }
  }
</style>
